// extracted by mini-css-extract-plugin
module.exports = {"noop":"FormTextInput_noop__nX6fX","inputText":"FormTextInput_inputText__1BP3b","expectedSubText":"FormTextInput_expectedSubText__URTJC"};